import { useMemo } from "react";

import { getEvidenceContributors } from "@/domains/evidence/hooks/useEvidenceFields";
import { useDisabledEvidenceTemplates } from "@/domains/evidence/hooks/useEvidenceTemplates";
import { DataBlockPermissionsOptions } from "@/domains/datablocks/types";

export const useDataBlockPermissions = (
  options: DataBlockPermissionsOptions = {},
) => {
  const { dataBlock, dataTemplate, currentUser } = options;
  const disabledTemplates = useDisabledEvidenceTemplates();

  const disabledTemplateTitles = useMemo(() => {
    return (disabledTemplates || []).reduce<string[]>((acc, template) => {
      acc.push(template.title);
      return acc;
    }, []);
  }, [disabledTemplates]);

  return useMemo(() => {
    return {
      canCreate: dataBlock?.canCreate || false,
      canView: dataBlock?.canView || false,
      canDelete: dataBlock?.canDelete || false,
      canEdit: dataBlock?.canEdit || false,
      isOwner: currentUser?.id === dataBlock?.createdBy?.id,
      isContributor:
        dataBlock && currentUser
          ? getEvidenceContributors(dataBlock).includes(currentUser.id)
          : false,
    };
  }, [dataBlock, dataTemplate, disabledTemplateTitles, currentUser]);
};
